module.exports = __webpack_public_path__ + "static/media/HDO.4bbd8a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/Home/HDO.png
// module id = 413
// module chunks = 0